import Vue from 'vue';

/*

*  使用方法

*  将以下代码复制到一个js文件中，然后在入口文件main.js中import引入即可；

*  给elementUI的dialog上加上 v-dialogDrag 指令就可以实现弹窗的全屏和拉伸了。

*  给dialog设置 :close-on-click-modal="false" , 禁止点击遮罩层关闭弹出层

*  如果是form表单，不要将提交等按钮放置el-form-item，以免在上下拉伸时被隐藏

*/

Vue.directive('dialogDrag', {
    bind(el, binding, vnode, oldVnode) {
        //弹窗
        const dragDom = el.querySelector('.el-dialog');

        //给弹窗加上overflow hidden；不然框内的标签可能超出dialog；
        dragDom.style.overflow = "hidden";

        //清除选择头部文字效果
        dragDom.onselectstart = new Function("return false");

        //加上可拖动cursor
        dragDom.style.cursor = 'move';

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

        let moveDown = (e) => {

            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - dragDom.offsetLeft;
            const disY = e.clientY - dragDom.offsetTop;

            document.onmousemove = function (e) {

                e.preventDefault(); // 移动时禁用默认事件

                // 通过事件委托，计算移动的距离
                const l = e.clientX - disX;
                const t = e.clientY - disY;

                // 移动当前元素 
                dragDom.style.left = `${l}px`;
                dragDom.style.top = `${t}px`;

                dragDom.style.margin = 'auto';
                dragDom.style.position = 'absolute';

                //将此时的位置传出去
                //binding.value({x:e.pageX,y:e.pageY})

            };

            document.onmouseup = function (e) {
                document.onmousemove = null;
                document.onmouseup = null;

            };

        }

        dragDom.onmousedown = moveDown;
    },
    componentUpdated(el,binding,vnode,oldVnode){ 
        if(vnode.elm.style.display === 'none'){
            //关闭弹窗时，恢复初始位置
            const dragDom = el.querySelector('.el-dialog');

            //样式
            dragDom.style.left = `initial`;
            dragDom.style.top = `initial`;
            dragDom.style.margin = '15vh auto 50px';
            dragDom.style.position = 'relative';
        }
    },
    unbind(el,binding,vnode,oldVnode) {
        //关闭弹窗时，恢复初始位置
        const dragDom = el.querySelector('.el-dialog');

        //样式
        dragDom.style.left = `initial`;
        dragDom.style.top = `initial`;
        dragDom.style.margin = '15vh auto 50px';
        dragDom.style.position = 'relative';
    },
})



// WEBPACK FOOTER //
// ./src/plugins/dialogDrag/dialogDrag.js